<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="80" inline>
        <FormItem label="标题">
          <Input placeholder="请输入" v-model="table.search.ExceptionTitle"></Input>
        </FormItem>
        <FormItem label="异常类型">
          <Input placeholder="请输入" v-model="table.search.ExcepitonType"></Input>
        </FormItem>
        <FormItem label="开始时间">
            <DatePicker
              type="date"
              v-model="table.search.StartTime"
              @on-change="table.search.StartTime=$event"

              placeholder="选择开始时间"
            ></DatePicker>
        </FormItem>
        <FormItem label="结束时间">
            <DatePicker
              type="date"
              v-model="table.search.EndTime"
              @on-change="table.search.EndTime=$event"

              placeholder="选择结束时间"
            ></DatePicker>
        </FormItem>
      </Form>
      <Button class="mr-3" type="success" @click="search">查询</Button>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
    ></DataTable>

    <!-- @selectionChange="selectionChange" -->
    <!--详情-->
    <Modal
      v-model="detailModal"
      title="日志详情"
      :footer-hide="true"
      
      :closable="false"
      width="60%"
    >
      <logDetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></logDetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import logDetail from "../exceptionlog/detail.vue";

export default {
  components: { DataTable, logDetail },
  data: function () {
    return {
      EmailSendFlagSelect: [],
      currentData: {},
      detailModal: false,
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "标题", key: "exceptionTitle" },
          { title: "异常类型", key: "excepitonType" },
          { title: "异常来源", key: "exceptionSource" },
          { title: "创建时间", key: "createDate" },
          {
            title: "操作",
            width: "80px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
              ]);
            },
          },
        ],
        apiUrl: "log/getExceptionLogList",
        search: {
          ExceptionTitle: "",
          ExcepitonType: "",
          StartTime: "",
          EndTime: "",
        },
      },
    };
  },

  created: function () {
    //this.EmailSendFlagSelect = this.$common.getJsonData("EmailSendFlag");
  },
  activated(){
    this.search()
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = data;
    },
  },
};
</script>
<style scoped>
</style>